module.exports = __webpack_public_path__ + "static/media/menu-subscription-icon.41d952f8.svg";